import { GridCellParams, GridColDef } from '@mui/x-data-grid-pro';
import React from 'react';
import ActionsCell from './Cells/ActionsCell/ActionsCell';
import AmountCell from './Cells/AmountCell/AmountCell';
import ClientCell from './Cells/ClientCell/ClientCell';
import ComplexityCell from './Cells/ComplexityCell/ComplexityCell';
import ConsultantCell from './Cells/ConsultantCell/ConsultantCell';
import ContentsCell from './Cells/ContentsCell/ContentsCell';
import DeliverableDateCell from './Cells/DeliverableDateCell/DeliverableDateCell';
import DescriptionCell from './Cells/DescriptionCell/DescriptionCell';
import ForcastedDateCell from './Cells/ForcastedDateCell/ForcastedDateCell';
import NameCell from './Cells/NameCell/NameCell';
import ReferenceCell from './Cells/ReferenceCell/ReferenceCell';
import ReviewCell from './Cells/ReviewCell/ReviewCell';
import ScopeCell from './Cells/ScopeCell/ScopeCell';
import TagsCell from './Cells/TagsCell/TagsCell';
import WorkloadCell from './Cells/WorkloadCell/WorkloadCell';
import OrderworkunitsIDCell from './Cells/OrderworkunitsIDCell/OrderworkunitsIDCell';
import OrderWorkunit from 'types/entities/OrderWorkunit';
import Scope from 'types/entities/Scope';
import User from 'types/entities/User';
import WorkunitComplexity from 'types/entities/WorkunitComplexity';
import CancellationReasonCell from './Cells/CancellationReasonCell/CancellationReasonCell';
import DeliveryManagerCell from './Cells/DeliveryManagerCell/DeliveryManagerCell';
import ModificationReasonCell from './Cells/ModificationReasonCell/ModificationReasonCell';
import PoReferenceCell from './Cells/PoReferenceCell/PoReferenceCell';
import StatusCell from './Cells/StatusCell/StatusCell';

type DeliveryTableGridCellParams<T> = GridCellParams<T, OrderWorkunit, any>;

export const columnField = {
  ACCEPTED: 'client_acceptance',
  ACTIONS: 'actions',
  AMOUNT: 'amount',
  CANCELLATION_REASON: 'cancellation_reason',
  CLIENT: 'client',
  DELIVERY_MANAGER: 'delivery_manager',
  COMMENTS: 'comments',
  COMPLEXITY: 'complexity',
  CONSULTANT: 'consultant',
  CONTENT: 'content',
  CONTENT2: 'content2',
  CONTENT3: 'content3',
  CONTENT4: 'content4',
  CONTENT5: 'content5',
  DELIVERABLE_DATE: 'deliverableDate',
  DESCRIPTION: 'workunit_desc',
  DISCOUNT: 'discount',
  FORECASTED_DATE: 'forcastedDate',
  MODIFICATION_REASON: 'modification_reason',
  NAME: 'workunit_name',
  RATING: 'rating',
  REFERENCE: 'workunit_reference',
  REVIEW: 'review',
  SCOPE: 'scope',
  SUBMITTED: 'submitted',
  TAGS: 'tags',
  VALIDATED: 'dm_validation',
  WORKLOAD: 'workload',
  PO_REFERENCE: 'purchase_order',
  STATUS: 'status',
  ID: 'id',
} as const;

// const defaultColumnParams: GridColDef = {
//   field: '',
//   headerName: '',
//   align: 'left',
//   headerAlign: 'center',
//   filterable: false,
//   sortable: true,
//   flex: 1,
// };

export const columnsParams = (scopes: any): GridColDef[] => [
  // Change '{ return [' to '('
  {
    field: columnField.TAGS,
    headerName: 'Tags',
    renderCell: (params: DeliveryTableGridCellParams<OrderWorkunit['label']>) => <TagsCell {...params.row} />,
    resizable: true,
    minWidth: 175,
  },
  {
    field: columnField.ID,
    headerName: 'Reference ID',
    renderCell: (params: DeliveryTableGridCellParams<number>) => <OrderworkunitsIDCell {...params.row} />,
    // renderHeader: (params: DeliveryTableGridColumnHeaderParams<string>) => <SearchHeaderCell {...params} />,
    resizable: true,
    align: 'center',
    minWidth: 100,
  },
  {
    field: columnField.NAME,
    headerName: 'Deliverables',
    renderCell: (params: DeliveryTableGridCellParams<string>) => <NameCell {...params.row} />,
    // renderHeader: (params: DeliveryTableGridColumnHeaderParams<string>) => <SearchHeaderCell {...params} />,
    minWidth: 100,
  },
  {
    field: columnField.SCOPE,
    headerName: 'Scope',
    renderCell: (params: DeliveryTableGridCellParams<Scope>) => <ScopeCell {...params.row} />,
    // renderHeader: (params: DeliveryTableGridColumnHeaderParams<string>) => (
    //   <SearchHeaderCell {...params} field="scope_id" options={scopes} />
    // ),
    minWidth: 120,
  },
  {
    field: columnField.REFERENCE,
    headerName: 'Reference',
    renderCell: (params: DeliveryTableGridCellParams<string>) => <ReferenceCell {...params.row} />,
    // renderHeader: (params: DeliveryTableGridColumnHeaderParams<string>) => <SearchHeaderCell {...params} />,
    minWidth: 60,
  },

  {
    field: columnField.PO_REFERENCE,
    headerName: 'Purchase Order',
    renderCell: (params: DeliveryTableGridCellParams<OrderWorkunit['charge']>) => <PoReferenceCell {...params.row} />,
    // renderHeader: (params: DeliveryTableGridColumnHeaderParams<string>) => <SearchHeaderCell {...params} />,
    resizable: true,
    minWidth: 100,
    align: 'center',
  },
  {
    field: columnField.DESCRIPTION,
    headerName: 'Description',
    renderCell: (params: DeliveryTableGridCellParams<string>) => <DescriptionCell {...params.row} />,
    // renderHeader: (params: DeliveryTableGridColumnHeaderParams<string>) => <SearchHeaderCell {...params} />,
    minWidth: 60,
  },
  {
    field: columnField.CONTENT,
    headerName: 'Content',
    minWidth: 100,
    renderCell: (params: DeliveryTableGridCellParams<string>) => (
      <ContentsCell row={params.row} target={columnField.CONTENT} />
    ),
    // renderHeader: (params: DeliveryTableGridColumnHeaderParams<string>) => <SearchHeaderCell {...params} />,
  },
  {
    field: columnField.CONTENT2,
    headerName: 'Content 2',
    minWidth: 100,
    renderCell: (params: DeliveryTableGridCellParams<string>) => (
      <ContentsCell row={params.row} target={columnField.CONTENT2} />
    ),
    // renderHeader: (params: DeliveryTableGridColumnHeaderParams<string>) => <SearchHeaderCell {...params} />,
  },
  {
    field: columnField.CONTENT3,
    headerName: 'Content 3',
    minWidth: 100,
    renderCell: (params: DeliveryTableGridCellParams<string>) => (
      <ContentsCell row={params.row} target={columnField.CONTENT3} />
    ),
    // renderHeader: (params: DeliveryTableGridColumnHeaderParams<string>) => <SearchHeaderCell {...params} />,
  },
  {
    field: columnField.CONTENT4,
    headerName: 'Content 4',
    minWidth: 100,
    renderCell: (params: DeliveryTableGridCellParams<string>) => (
      <ContentsCell row={params.row} target={columnField.CONTENT4} />
    ),
    // renderHeader: (params: DeliveryTableGridColumnHeaderParams<string>) => <SearchHeaderCell {...params} />,
  },
  {
    field: columnField.CONTENT5,
    headerName: 'Content 5',
    minWidth: 100,
    renderCell: (params: DeliveryTableGridCellParams<string>) => (
      <ContentsCell row={params.row} target={columnField.CONTENT5} />
    ),
    // renderHeader: (params: DeliveryTableGridColumnHeaderParams<string>) => <SearchHeaderCell {...params} />,
  },
  {
    field: columnField.COMPLEXITY,
    headerName: 'Complexity',
    renderCell: (params: DeliveryTableGridCellParams<WorkunitComplexity>) => <ComplexityCell {...params.row} />,
    minWidth: 80,
  },
  {
    field: columnField.AMOUNT,
    headerName: 'Price',
    renderCell: (params: DeliveryTableGridCellParams<number>) => <AmountCell {...params.row} />,
    minWidth: 60,
  },
  {
    field: columnField.WORKLOAD,
    headerName: 'Workload',
    renderCell: (params: DeliveryTableGridCellParams<OrderWorkunit['charge']>) => <WorkloadCell {...params.row} />,
    minWidth: 60,
  },
  {
    field: columnField.DELIVERABLE_DATE,
    headerName: 'Initial delivery date',
    renderCell: (params: DeliveryTableGridCellParams<string>) => <DeliverableDateCell {...params.row} />,
    minWidth: 60,
  },
  {
    field: columnField.FORECASTED_DATE,
    headerName: 'New expected delivery date',
    renderCell: (params: DeliveryTableGridCellParams<string>) => <ForcastedDateCell {...params.row} />,
    minWidth: 60,
  },
  {
    field: columnField.MODIFICATION_REASON,
    headerName: 'Modification reason',
    renderCell: (params: DeliveryTableGridCellParams<string>) => <ModificationReasonCell {...params.row} />,
    minWidth: 60,
  },
  {
    field: columnField.CANCELLATION_REASON,
    headerName: 'Cancellation reason',
    renderCell: (params: DeliveryTableGridCellParams<number>) => <CancellationReasonCell {...params.row} />,
    minWidth: 60,
  },
  {
    field: columnField.CONSULTANT,
    headerName: 'Consultant',
    renderCell: (params: DeliveryTableGridCellParams<User>) => <ConsultantCell {...params.row} />,
    resizable: true,
    minWidth: 80,
  },
  {
    field: columnField.DELIVERY_MANAGER,
    headerName: 'Delivery Manager',
    renderCell: (params: DeliveryTableGridCellParams<User>) => <DeliveryManagerCell {...params.row} />,
    resizable: true,
    minWidth: 80,
  },

  {
    field: columnField.CLIENT,
    headerName: 'Client',
    renderCell: (params: DeliveryTableGridCellParams<User>) => <ClientCell {...params.row} />,
    minWidth: 60,
  },
  // {
  //   field: columnField.SUBMITTED,
  //   renderCell: (params: DeliveryTableGridCellParams<OrderWorkunit['mission_advancement_id']>) => (
  //     <SubmittedCell {...params.row} />
  //   ),
  //   minWidth: 100,
  //   align: 'center',
  // },

  // {
  //   field: columnField.VALIDATED,
  //   renderCell: (params: DeliveryTableGridCellParams<OrderWorkunit['mission_advancement_id']>) =>
  //     params.row ? <ValidatedCell row={params.row} /> : <> </>,
  //   resizable: true,
  //   minWidth: 100,
  //   align: 'center',
  // },
  // {
  //   field: columnField.ACCEPTED,
  //   renderCell: (params: DeliveryTableGridCellParams<number>) => <AcceptedCell row={params.row} />,
  //   resizable: true,
  //   align: 'center',
  //   minWidth: 100,
  // },

  // {
  //   field: columnField.COMMENTS,
  //   renderCell: (params: DeliveryTableGridCellParams<MissionComment[]>) => <CommentsCell {...params.row} />,
  //   resizable: true,
  //   minWidth: 50,
  //   align: 'center',
  // },

  // {
  //   field: columnField.DISCOUNT,
  //   renderCell: (params: DeliveryTableGridCellParams<number>) => <DiscountCell {...params.row} />,
  //   minWidth: 60,
  // },

  // {
  //   field: columnField.RATING,
  //   renderCell: (params: DeliveryTableGridCellParams<string | null>) => <RatingCell {...params.row} />,
  //   minWidth: 60,
  //   resizable: true,
  //   align: 'center',
  // },
  {
    field: columnField.REVIEW,
    headerName: 'Comments',
    renderCell: (params: DeliveryTableGridCellParams<number>) => <ReviewCell {...params.row} />,
    minWidth: 60,
  },
  {
    field: columnField.STATUS,
    headerName: 'Status',
    renderCell: (params: DeliveryTableGridCellParams<number>) => <StatusCell {...params.row} />,
    minWidth: 100,
  },
  {
    field: columnField.ACTIONS,
    headerName: 'Actions',
    renderCell: (params: DeliveryTableGridCellParams<null>) => <ActionsCell {...params.row} />,
    resizable: true,
    align: 'center',
    minWidth: 50,
  },
];
